import {
  StyleSheet,
  Text,
  View,
  Image,
  FlatList,
  TouchableOpacity,
  ScrollView,
} from "react-native";
import React, { useEffect, useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppScreens } from "../../Utility/AppScreens";
import { MobileDeviceNavigationHeader } from "./Common/MobileDeviceNavigationHeader";
import { toast } from "react-toastify";
import { base_url, endpoints } from "../../../Api/configs";
import { getLoginData } from "../../../utility/AppStoreData";
import dayjs from "dayjs";
import { fetchTicketsSoldOverview } from "../../../services/ticketsAPI";
import Skeletons from "../../../Components/skeleton-components/Skeletons";
import NoDataFound from "../../../Components/NoDataFound";
import Header from "./Common/Header";
import { ScreenBGGradientView } from "../../../common/CommonView";

const transactionData = [
  {
    id: "1",
    date: "01/01/2024",
    eventname: "Name of event",
    ticketsold: "450",
    amountreceived: "$12.99",
  },
  {
    id: "2",
    date: "02/01/2024",
    eventname: "Name of event ",
    ticketsold: "450",
    amountreceived: "$19.99",
  },
];

export default function TicketHistory() {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const [showLoader, setShowLoader] = useState(false);
  const [userData, setUserData] = useState(null); //Login user data
  const [arrTicketsSoldOverview, setArrTicketsSoldOverview] = useState([]);
  const isSmallOrXS =
    deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;
  let accessToken = "";
  let skeletonCards = Array(10).fill(0);
  useEffect(() => {
    getLoginUserData((loginData) => {
      console.log("Login Data successfully fetch:- ");
    });
  }, []);

  async function getLoginUserData(successResponse) {
    const data = await getLoginData();

    if (data != null) {
      setUserData(data);
      accessToken = data.AccessToken;
      successResponse(data);

      getTicketsSoldOverview((response) => {
        setArrTicketsSoldOverview(response.ticketsSoldOverview);
      });
    }
  }

  const getTicketsSoldOverview = async (successResponse) => {
    setShowLoader(true);

    try {
      const response = await fetchTicketsSoldOverview(accessToken);
      setShowLoader(false);

      if (response.statusCode === 200) {
        successResponse(response.body);
      } else {
        toast.error(response.body.error);
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };

  const renderTransactionItem = ({ item, index }) => (
    <View key={index} style={{ paddingHorizontal: 10 }}>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          height: 40, // Ensure enough height for each row
          paddingVertical: 10, // Adjust to add space
        }}
      >
        <View style={{ flex: 1 }}>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              { color: "white", textAlign: "left" },
            ]}
          >
            {dayjs(item.eventStart).format("DD/MM/YYYY")}
          </Text>
        </View>
        <View style={{ flex: 2 }}>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              { color: "white", textAlign: "center" },
            ]}
          >
            {item.title}
          </Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              { color: "white", textAlign: "center" },
            ]}
          >
            {item.ticketsSold}
          </Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_14,
              { color: "white", textAlign: "right" },
            ]}
          >
            ${item.amountSold ? item.amountSold : 0}
          </Text>
        </View>
      </View>
      <View style={[styles.centerDivider, { marginVertical: 5 }]} />
    </View>
  );

  return (
    <View
      style={{
        flex: 1,
      }}
    >
      <ScreenBGGradientView />
      {/* Mobile Device navigation Header */}
      {/* {deviceSize === DEVICE_SIZES.XS ? (
        <MobileDeviceNavigationHeader
          btnNotificationTapped={() => {
            navigateToScreen(navigation, AppScreens.NotificationScreen
                // { txtSearch: searchEvent });
          }}
          btnSettingTapped={() => {
            navigateToScreen(navigation, AppScreens.SettingWebScreen
                // { txtSearch: searchEvent });
          }}
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen
                // { txtSearch: searchEvent });
          }}
        />
      ) : null} */}
      <Header
        btnSearchTapped={() => {
          navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
        }}
        btnWalletTapped={() => {}}
        btnStartTutorialTapped={() => {}}
        btnMessageTapped={() => {}}
        btnNotificationTapped={() => {}}
        btnProfileTapped={() => {}}
      />
      <View style={styles.container}>
        {/* {deviceSize !== DEVICE_SIZES.XS ? (
          <Image
            source={AppImages.icNotificationbing}
            style={{
              alignSelf: "flex-end",
              height: 30,
              width: 30,
              marginVertical: 5,
            }}
          />
        ) : null} */}
        {showLoader ? (
          <Skeletons
            height={45}
            width={"250px"}
            style={{
              borderRadius: 10,
              marginTop: 6,
            }}
          />
        ) : (
          <Text
            style={[AppFontStyle.BOLD_ANYBODY_32, { color: AppColors.white }]}
          >
            Ticket History
          </Text>
        )}
        <ScrollView
          horizontal={isSmallOrXS}
          contentContainerStyle={{ flexDirection: "row", flexGrow: 1 }}
          showsHorizontalScrollIndicator={true}
        >
          <View style={[styles.TicketBeltView]}>
            <View style={[styles.centerDivider, { marginVertical: 10 }]} />
            {showLoader ? (
              <Skeletons height={40} width={"100%"} />
            ) : (
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  backgroundColor: AppColors.grayColor_565656,
                  paddingHorizontal: 15,
                  borderRadius: 12,
                  paddingVertical:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 12
                      : 14,
                }}
              >
                {["Date", "Event", "Sold", "Received"].map((item, index) => (
                  <View key={index} style={{ flex: index === 1 ? 2 : 1 }}>
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                          ? AppFontStyle.BOLD_ANYBODY_12
                          : AppFontStyle.BOLD_ANYBODY_14,
                        {
                          minWidth: 100,
                          color: AppColors.white,
                          textAlign: "center",
                          // index === 0
                          //   ? "left"
                          //   : index === 1 || index === 2
                          //   ? "center"
                          //   : "left",
                        },
                      ]}
                    >
                      {item}
                    </Text>
                  </View>
                ))}
              </View>
            )}
            {showLoader ? (
              skeletonCards.map((index) => (
                <Skeletons
                  height={40}
                  width={"100%"}
                  style={{ marginTop: 10 }}
                />
              ))
            ) : arrTicketsSoldOverview.length === 0 ? (
              <View
                style={{
                  flex: 1,
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 300,
                  marginRight: 0,
                  // deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  //   ? 275
                  //   : 0,
                }}
              >
                <NoDataFound text="No Ticket Found" />
              </View>
            ) : (
              <FlatList
                style={{ flex: 1 }}
                data={arrTicketsSoldOverview}
                // renderItem={renderTransactionItem}
                renderItem={({ item, index }) => {
                  return renderTransactionItem({ item, index });
                }}
                keyExtractor={(item) => item.id}
              />
            )}
          </View>
        </ScrollView>
        <TouchableOpacity
          style={styles.backButtonStyle}
          onPress={() => {
            navigation.dispatch(StackActions.pop());
          }}
        >
          <Text style={[AppFontStyle.BOLD_ANYBODY_12, { color: "white" }]}>
            Back
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    TicketBeltView: {
      width: "100%",
      borderRadius: 10,
      paddingBottom: 15,
      gap: 10,
    },
    container: {
      flex: 1,
      backgroundColor: "transparent",
      paddingHorizontal: "3%", // Adjust padding based on device size
      paddingTop: "2.5%",
    },
    buttonStyle: {
      borderRadius: 10,
      height: 36,
      width: 215,
      flexDirection: "row",
      gap: 8,
      justifyContent: "center",
      alignItems: "center",
    },
    headerWrapper: {
      flexDirection: "row",
      alignItems: "center",
      marginTop: 10,
    },
    headerTextLeft: {
      flex: 1.5,
    },
    headerTextRight: {
      flex: 0.5,
      alignSelf: "center",
      textAlign: "center",
    },
    centerDivider: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      height: 2,
    },
    itemStyle: {
      marginVertical: 5,
    },
    itemTextWrapper: {
      alignSelf: "center",
      gap: 5,
      marginStart: 35,
      marginEnd: 35,
    },
    itemLeft: {
      flexDirection: "row",
      flex: 1.5,
    },
    itemRight: {
      flex: 0.5,
      alignSelf: "center",
      justifyContent: "center",
      alignItems: "center",
    },
    backButtonStyle: {
      height: 40,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      paddingHorizontal: 45,
      paddingVertical: 12,
      borderRadius: 10,
      alignSelf: "flex-start",
      marginVertical: 20,
      marginHorizontal: 20,
    },
    itemWrapper: {
      flexDirection: "row",
      paddingVertical: 12,
      flexWrap: "wrap",
      gap: 20,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      headerWrapper: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
      },
      headerTextLeft: {
        flex: 1.5,
      },
      headerTextRight: {
        flex: 0.5,
        alignSelf: "center",
        textAlign: "center",
      },
      centerDivider: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        height: 2,
      },
      itemStyle: {
        marginVertical: 5,
      },
      itemTextWrapper: {
        alignSelf: "center",
        gap: 5,
        marginStart: 35,
        marginEnd: 35,
      },
      itemLeft: {
        flexDirection: "row",
        flex: 1.5,
      },
      itemRight: {
        flex: 0.5,
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
      },
      buttonStyle: {
        borderRadius: 10,
        height: 36,
        width: 215,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      itemWrapper: {
        flexDirection: "row",
        paddingVertical: 12,
        flexWrap: "wrap",
        gap: 20,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      headerWrapper: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
      },
      headerTextLeft: {
        flex: 1.5,
      },
      headerTextRight: {
        flex: 0.5,
        alignSelf: "center",
        textAlign: "center",
      },
      centerDivider: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        height: 2,
      },
      itemStyle: {
        marginVertical: 5,
      },
      itemTextWrapper: {
        alignSelf: "center",
        gap: 5,
        marginStart: 35,
        marginEnd: 35,
      },
      itemLeft: {
        flexDirection: "row",
        flex: 1.5,
      },
      itemRight: {
        flex: 0.5,
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
      },
      buttonStyle: {
        borderRadius: 10,
        height: 36,
        width: 180,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      itemWrapper: {
        flexDirection: "row",
        paddingVertical: 12,
        flexWrap: "wrap",
        gap: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      headerWrapper: {
        flexDirection: "row",
        alignItems: "center",
        marginTop: 10,
      },
      headerTextLeft: {
        flex: 1.5,
      },
      headerTextRight: {
        flex: 0.5,
        alignSelf: "center",
        textAlign: "center",
      },
      centerDivider: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        height: 2,
      },
      itemStyle: {
        marginVertical: 5,
      },
      itemTextWrapper: {
        alignSelf: "center",
        gap: 5,
        marginStart: 35,
        marginEnd: 35,
      },
      itemLeft: {
        flexDirection: "row",
        flex: 1.5,
      },
      itemRight: {
        flex: 0.5,
        alignSelf: "center",
        justifyContent: "center",
        alignItems: "center",
      },
      buttonStyle: {
        borderRadius: 10,
        height: 36,
        width: 215,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      itemWrapper: {
        flexDirection: "row",
        paddingVertical: 12,
        flexWrap: "wrap",
        gap: 20,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: "transparent",
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      headerWrapper: {
        flexDirection: "column",
        alignItems: "center",
        marginTop: 10,
        gap: 10,
      },
      headerTextLeft: {
        flex: 1,
      },
      headerTextRight: {
        flex: 1,
        alignSelf: "flex-end",
        textAlign: "center",
      },
      centerDivider: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        height: 2,
      },
      itemStyle: {
        marginVertical: 5,
      },
      itemTextWrapper: {
        alignSelf: "center",
        gap: 5,
        marginStart: 35,
        marginEnd: 35,
      },
      itemLeft: {
        flexDirection: "row",
        flex: 1,
      },
      itemRight: {
        flex: 1,
        alignSelf: "flex-end",
        justifyContent: "flex-end",
        alignItems: "center",
      },
      buttonStyle: {
        borderRadius: 10,
        height: 36,
        width: 215,
        flexDirection: "row",
        gap: 8,
        justifyContent: "center",
        alignItems: "center",
      },
      itemWrapper: {
        flexDirection: "column",
        paddingVertical: 12,
        flexWrap: "wrap",
        gap: 20,
      },
    },
  }
);
